import React, { useEffect } from 'react';
import AdvertiserDetailsTransactionsReportsLoader from '../../../../../core/components/advertiser/advertiserdetails/transactions/AdvertiserDetailsTransactionsReportsLoader';
import AdvertiserDetailsTransactionsReportController from '../../../../../core/components/advertiser/advertiserdetails/transactions/AdvertiserDetailsTransactionsReportController';
import { HasAccess } from '@permify/react-role';
import DetailBar from '../components/DetailBar';
import { LoadingPage } from '../../../../shared/LoadingPage';
import { Row, Col, Card, Typography } from 'antd';
import DualAxisChart from '../../../../shared/charts/DualAxisChart';
import { summaryScale } from '../../utils/summaryScale';
import moment from 'moment';
import TransactionsTable from '../components/TransactionsTable';
import TopCreatives from '../components/TopCreatives';
import TopImpressionDomains from '../components/TopImpressionDomains';
import TopInventoryTypes from '../components/TopInventoryTypes';

const TransactionsDetailsView = ({ setRef, ...props }) => {
  return (
    <AdvertiserDetailsTransactionsReportsLoader {...props}>
      <AdvertiserDetailsTransactionsReportController {...props}>
        <TransactionsTab setRef={setRef} {...props} />
      </AdvertiserDetailsTransactionsReportController>
    </AdvertiserDetailsTransactionsReportsLoader>
  );
};

const TransactionsTab = ({
  advertiser,
  reportDataSummary,
  reportDataSummaryLoading,
  changeDatePicker,
  topCreatives,
  topImpressions,
  topInventoryTypes,
  setRef,
  setTransactionsReportData,
  resetSavedSession,
  hasSavedSession,
}) => {
  const { byDates = [], transactions = [] } = reportDataSummary || {};

  useEffect(() => {
    setTransactionsReportData(reportDataSummary);
  }, [reportDataSummary, setTransactionsReportData]);

  if (reportDataSummaryLoading) return <LoadingPage />;

  const dsp = advertiser?.impressionsTag?.dsp || '';

  const dropDownOptions = [
    { key: 'impressions', display: 'Impressions' },
    { key: 'transactions', display: 'Transactions' },
    { key: 'revenue', display: 'Revenue' },
    { key: 'customers', display: 'Customers' },
  ];

  return (
    <HasAccess permissions={['default', 'defaultSSO', 'advertiserSSO']}>
      <DetailBar
        {...reportDataSummary.summary}
        startDate={advertiser.startDate}
        endDate={advertiser.endDate}
        module="TRANSACTIONS"
      />

      {advertiser.attributionFilter && (
        <Card size="small" style={{ marginBottom: 16 }}>
          <Typography.Text type="secondary">
            Attribution Filter:{' '}
            <Typography.Text strong>{advertiser.attributionFilter}</Typography.Text>
          </Typography.Text>
        </Card>
      )}

      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <DualAxisChart
            byDate={byDates}
            xAxis="date"
            options={dropDownOptions}
            defaultLeftYValue={dropDownOptions[0]}
            defaultRightYValue={dropDownOptions[1]}
            setRef={setRef}
            customScale={summaryScale}
            onDatePickerChange={({ data, dates, rangeKey }) => {
              changeDatePicker(dates);
            }}
            has6MonDisables={false}
            allTimeDateRange={[moment(advertiser.startDate), moment(advertiser.endDate)]}
            onClearSessionData={resetSavedSession}
            hasSavedSession={hasSavedSession}
          />
        </Col>
        <Col xs={24}>
          <TransactionsTable
            data={transactions ? transactions : []}
            total={0}
            topImpressions={topImpressions}
            dsp={dsp}
          />
        </Col>
        <Col xs={24}>
          <TopCreatives data={topCreatives} />
        </Col>
        <Col xs={24}>
          <TopImpressionDomains data={topImpressions} />
        </Col>
        <Col xs={24}>
          <TopInventoryTypes data={topInventoryTypes} />
        </Col>
      </Row>
    </HasAccess>
  );
};

export default TransactionsDetailsView;
